import React from 'react';

const Format7 = ({ modifyForm = {} }) => {
    // Default fallbacks
    const defaultColumns = [];
    const defaultCopies = [{ name: 'Original Copy', value: 1, check: true }];

    // Helper to get visible columns
    const getVisibleColumns = (columns) => {
        return (columns || defaultColumns).filter(col => col.check);
    };

    const visibleColumns = getVisibleColumns(modifyForm.lr_table);
    const activeCopy = (modifyForm.copies || defaultCopies).find(copy => copy.check) || defaultCopies[0];

    // Company / Header Info
    const {
        company_name = "Sakshi Freight Carrier",
        address = "125-A, SCHEME NO.78, INDORE, Indore, 452001",
        email = "sakshicarriers@gmail.com",
        phone = "+91 9200031247",
        gstin = "GST NO. 23ADGFS8194L2ZF"
    } = modifyForm;

    // Consigner Info
    const {
        consigner_name = "Parle Biscuites Pvt. Ltd.",
        consigner_c_o = "C/O- Market Loading Transportation",
        consigner_address = "125 sector A scheme no. 78, indore- 452015",
        consigner_gstin = ""
    } = modifyForm;

    // Consignee Info
    const {
        consignee_name = "",
        consignee_address = ", ,",
        consignee_contact = "",
        consignee_gstin = "",
        consignee_code = ""
    } = modifyForm;

    // Trip Info
    const {
        trip_no = "6026",
        vehicle_no = "MH40BG4590",
        lr_date = "25/05/2024",
        mlr_no = "12345"
    } = modifyForm;

    // Item Description
    const item_desc = modifyForm.item_desc || "Biscuits, Confectionary, Snacks";

    // Remarks & T&C
    const remark = modifyForm.remark || "";
    const terms_conds = modifyForm.terms_conds || "Delivery Note should be given within the 30 Days of Delivery else we are liable to deduct due Freight. 2. Delayed Delivery will attract Damage, Haulting Charges as per the rules. 3. We will not be responsible for any Shortage if Truck is unloaded in Part Delivery in Tempo/Trucks.";

    // Table Data (support single row for now)
    const tableData = modifyForm.lr_table_data && modifyForm.lr_table_data.length > 0
        ? modifyForm.lr_table_data[0]
        : {};

    return (
        <>
            <style>{`
     
        @page {
            margin: -10px;
        }

        /* Note: Necessary for the pdf */
        @import url('https://fonts.googleapis.com/css?family=Roboto:400,500,700,900&display=swap');

        body {
            margin: 0px;
        }


        td.text-left.width_75.font14 {
            font-size: 12px;
            position: relative;

        }

        table.table_gray_bg {
            background: #efefef !important;
            margin: 0;
            font-size: 13px;
            border-bottom: 1px solid #ccc;
            -webkit-print-color-adjust: exact;
            border-top: 1px solid #ccc;
            margin-top: -1px;
            border-right: 1px solid #ccc;
        }

        .table_gray_bg td {
            padding: 5px 15px !important;
        }

        .item_description {
            margin: 2px 0;
        }

        .address_new {
            margin: 0px;
            margin-bottom: 5px;
        }

        .Unloading_details td {
            line-height: 21px !important;
        }

        .height_div.paymentmode_height {
            height: 150px;
        }

        .height_div.paymentmode_height td {
            height: 20px !important;
        }

        .remarK-div {
            height: 34px;
        }

        td.remarK-div p {
            margin: 0;
            height: 60px;
        }

        .gst_invoiceno_table .border_table tr td:nth-child(1) {
            width: 75px !important;
        }

        .gst_invoiceno_table .border_table tr td:nth-child(2) {
            width: 110px !important;
        }

        .gst_invoiceno_table .border_table tr td:nth-child(3) {
            width: 110px !important;
        }

        .gst_invoiceno_table .border_table tr td:nth-child(4) {
            width: 110px !important;
        }

        .gst_invoiceno_table .border_table tr td:nth-child(5) {
            width: 60px !important;
        }

        .gst_invoiceno_table .border_table tr td:nth-child(6) {
            width: 60px !important;
        }

        .gst_invoiceno_table .border_table tr td:nth-child(7) {
            width: 60px !important;
        }

        .gst_invoiceno_table .border_table tr td:nth-child(8) {
            width: 70px !important;
        }

        .graY-bg {
            background: #000 !important;
            border-bottom: 1px solid #ccc;
            -webkit-print-color-adjust: exact;
            color: white;
        }

        .overly_table thead td {
            border-top: 1px solid #ccc;
            border-bottom: 1px solid #ccc;
        }

        p.CONSIGNEE {
            margin: 0;
        }

        .gst_invoiceno_table td {
            height: 22px !important;
            border-top: 1px solid #efefef;
            line-height: 23px !important;
        }

        .height_div.gst_invoiceno_table theda tr td {
            border-bottom: 1px solid #ccc !important;
        }

        .gst_invoiceno_table .border_table tr.tfoot_bg td {
            line-height: 24px;
        }

        table.footer_table td {
            padding-left: 15px;
            padding-right: 15px;
        }

        table.footer_table {
            border-bottom: 1px solid #ccc;
        }

        .footer.margintop {
            margin-top: 60px !important;
        }

        .new_table td {
            line-height: 16px !important;
        }

        .poweredby {
            position: absolute;
            right: 0;
            font-size: 11px;
            margin-top: 3px;
            padding-right: 15px
        }

        .footer p {
            margin: 0
        }

        table.footer_table {
            position: relative
        }

        .footer {
            margin-top: 60px;
            font-weight: 700;
            padding-left: 15px;
            padding-right: 15px
        }

        td.Unloading_details .width_35 {
            font-weight: 400
        }

        /*table.footer_table{border-top:1px solid #ccc}*/
        table.routeDIv td {
            line-height: 22px;
            padding: 2px 15px
        }

        h2.payment_class {
            font-size: 15px;
            padding-left: 14px;
            margin-top: 5px;
            margin-bottom: 5px
        }

        td.bold_font {
            font-weight: 700
        }

        /* .padding-2mm{padding:2mm}*/
        .invoice-box {
            padding: 3px;
            font-size: 12px;
            line-height: 16px;
            font-family: Roboto, sans-serif;
            color: #222;
            margin: 0 auto
        }

        .Remark {
            height: 1cm
        }

        span.orignal_copy {
            text-align: right;
            float: right;
            font-size: 11px;
            line-height: 17px
        }

        .border_b {
            border-bottom: 1px solid #ccc
        }

        table.p_comm td {
            padding: 2px 5px
        }

        table.p_comm {
            border-right: 1px solid #ccc
        }

        .width_30 {
            width: 15%
        }

        .text_center {
            text-align: center;
            display: block
        }

        .bold_text {
            font-weight: 700
        }

        .border_box {
            border: 1px solid #cccc
        }

        .p_0 {
            padding: 0 !important
        }

        span.poweredby {
            position: absolute;
            bottom: -20px;
            text-align: right;
            width: 100%;
            right: 4px;
            font-size: 9px
        }

        .Gst_in {
            font-weight: 900 !important;
            margin-top: 4px !important;
            margin-bottom: 0 !important
        }

        .Extra_p td {
            padding: 5px 15px !important
        }

        .address_outer p {
            margin: 0;
            margin-bottom: 5px
        }

        .Extra_p {
            border-top: 1px solid #ccc;
            position: relative
        }

        .border_r {
            border-right: 1px solid #ccc
        }

        .Signature_height {
            height: 1.63cm
        }

        /*.Address{height:35px}*/
        .invoice-box table {
            width: 100%;
            line-height: inherit;
            text-align: left;
            border-collapse: collapse
        }

        .top_heading p {
            margin-top: 10px;
            font-size: 12px;
            font-weight: 400;
            line-height: 17px;
            margin-bottom: 10px
        }

        .height_div td {
            height: 18px
        }

        .top_heading_P {
            font-size: 22px !important;
            margin-bottom: 0 !important;
            margin-top: 0 !important;
            font-weight: 700 !important;
        }

        .left_table {
            border-right: 1px solid #ccc
        }

        .invoice-box table td {
            vertical-align: top;
            line-height: 20px
        }

        .text-left {
            text-align: left
        }

        .border_table thead td {
            font-weight: 700;
            padding: 6px 5px;
            font-size: 12px
        }

        .top_heading {
            padding: 10px 0 5px 15px
        }

        .invoice-box table tr.information table td {
            padding-bottom: 40px
        }

        .invoice-box table tr.heading td {
            background: #eee;
            border-bottom: 1px solid #ddd;
            font-weight: 700
        }

        .border_table td {
            padding: 8px 5px;
            height: 18px
        }

        tr.tfoot_bg td {
            line-height: 24px;
            border-top: 1px solid #ccc !important;
            border-bottom: 1px solid #ccc !important;
        }

        .overly_table td {
            height: 21px
        }

        .invoice-box table tr.details td {
            padding-bottom: 20px
        }

        .Heading_right {
            background: #efefef !important;
            margin: 0;
            padding: 4px 15px;
            font-size: 13px;
            border-bottom: 1px solid #ccc;
            -webkit-print-color-adjust: exact;
            border-top: 1px solid #ccc;
            margin-top: -1px;
            border-right: 1px solid #ccc
        }

        .invoice-box table tr.total td:nth-child(2) {
            border-top: 2px solid #eee;
            font-weight: 700
        }

        table.table_right thead td {
            padding: 0
        }

        .table_right td {
            padding: 3px 15px
        }

        .termsAndCondiotion {
            font-size: 12px;
            margin: 0;
            margin-bottom: 5px;
            margin-top: 5px
        }

        .b_0 {
            border-bottom: 0 !important;
            border-top: 0 !important
        }

        td.text-left.width_75 {
            text-align: right
        }

        .width_35 {
            width: 50%
        }

        .height_div {
            position: relative
        }

        td.Unloading_details {
            border-left: 1px solid #ccc;
            padding-top: 6px
        }

        tr.bg_darkGray {
            background: #444 !important;
            color: #fff
        }

        tr.bg_darkGray td {
            background: #444 !important;
            color: #fff
        }

        .overly_table {
            position: absolute;
            width: 100%;
            top: 0;
            border-bottom: 1px solid #ccc;
        }

        .border_table tr td:nth-child(1) {
            width: 80px;
            border-left: 0;
            padding-left: 15px
        }

        .border_table tr td:nth-child(2) {
            width: 50px
        }

        .border_table tr td:nth-child(3) {
            width: 150px
        }

        .border_table tr td:nth-child(4) {
            width: 130px
        }

        .border_table tr td:nth-child(5) {
            width: 76px;
            padding-right: 10px
        }

        .border_table tr td:nth-child(6) {
            width: 150px
        }

        .tfoot_bg td {
            padding: 0px 10px;
            background: #efefef !important;
            font-size: 12px;
            -webkit-print-color-adjust: exact
        }

        

        .address_bottom {
            margin: 0;
            height: 45px;
            line-height: 12px;
            padding-top: 0;
            margin-top: 0;
            font-size: 10px;
            padding-bottom: 4px
        }

        .address_bottom p {
            margin-bottom: 0
        }

        .m_b_10 {
            margin-bottom: 10px;
            margin-top: 10px
        }

        .oP_none {
            opacity: 0
        }

        .Address span {
            display: block;
            margin-bottom: 2px
        }

        .address_outer {
            height: 33px
        }

        .border_table.border_none td {
            border-color: #fff !important;
            line-height: 24px
        }

        .address_outer.address_box p {
            width: 500px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap
        }

        .top_heading_left {
            text-align: left !important;
        }

        .sheet.padding-2mm {
            padding: 2mm;
            background: white;
        }


        /* Spoiled Stock Declaration */

        .__stockSpoil_bx {
            border: 1px solid #CCCCCC;
            padding: 15px 18px;
            font-family: Roboto, sans-serif;
            text-align: center;
            color: #000000;
            width: calc(100% - 6px);
            box-sizing: border-box;
            margin: 12px auto 0px;
        }

        .__stk_head h4 {
            font-size: 16.6px;
            font-weight: 700;
            text-transform: uppercase;
            margin: 0px 0px 5px;
        }

        .__stk_head p {
            font-size: 10px;
            margin: 0px;
        }

        .__stk_tpDetail {
            display: flex;
            gap: 18px 14px;
            flex-wrap: wrap;
            padding: 25px 0px 0px;
            text-align: left;
        }

        .__stk_tpDetail_last {
            gap: 12px;
        }

        .__stk_lFx {
            font-size: 12px;
            display: flex;
            flex: 1;
            align-items: baseline;
        }

        .__stk_lFx_full {
            flex: 0 0 100%;
        }

        .__stk_lFx p {
            margin: 0px;
        }

        .__stk_lFx span {
            flex: 1;
            border-bottom: 1px solid;
        }

        .__stk_lFx span.__stk_check {
            width: 16px;
            height: 16px;
            display: inline-block;
            border: 1px solid #D9D9D9;
            border-radius: 2px;
            top: 0px !important;
        }

        .__stk_tpDetail.__stk_tpDetail_last .__stk_lFx.__stk_lFx_full p {
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .__stk_tpDetail.__stk_tpDetail_last .__stk_lFx.__stk_lFx_full span {
            position: relative;
            top: -4px;
        }

        .stk_signBx {
            min-height: 90px;
            text-align: right;
            display: flex;
            align-items: flex-end;
            justify-content: flex-end;
        }

        .stk_signBx p {
            font-size: 12px;
            color: #000000;
            margin: 0px;
        }


        
        /* Spoiled Stock Declaration */





        @page a4-portrait {
            size: A4 portrait;
        }

        @page a4-landscape {
            size: A4 landscape;
        }

        @page a5-portrait {
            size: A5 portrait;
        }

        @page a5-landscape {
            size: A5 landscape;
        }

        .sheet-content_nw4 {
            transform-origin: top left;
            transition: transform 0.2s ease;
            margin: 0 auto;
            page-break-after: always;
        }

        /* A4 Portrait */
        .sheet-content_nw4.a4-portrait {
            page: a4-portrait;
            width: 210mm;
        }

        /* A4 Landscape */
        .sheet-content_nw4.a4-landscape {
            page: a4-landscape;
            width: 297mm;
        }

        /* A5 Portrait */
        .sheet-content_nw4.a5-portrait {
            page: a5-portrait;
            width: 148.5mm;
        }

        /* A5 Landscape */
        .sheet-content_nw4.a5-landscape {
            page: a5-landscape;
            width: 210mm;
        }


        @media (max-width: 319px) {
            .sheet-content_nw4 {
                transform: scale(calc(20% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 320px) and (max-width: 339px) {
            .sheet-content_nw4 {
                transform: scale(calc(20% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 340px) and (max-width: 359px) {
            .sheet-content_nw4 {
                transform: scale(calc(20% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 360px) and (max-width: 379px) {
            .sheet-content_nw4 {
                transform: scale(calc(22% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 380px) and (max-width: 399px) {
            .sheet-content_nw4 {
                transform: scale(calc(24% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 400px) and (max-width: 419px) {
            .sheet-content_nw4 {
                transform: scale(calc(26% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 420px) and (max-width: 439px) {
            .sheet-content_nw4 {
                transform: scale(calc(26% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 440px) and (max-width: 459px) {
            .sheet-content_nw4 {
                transform: scale(calc(28% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 460px) and (max-width: 479px) {
            .sheet-content_nw4 {
                transform: scale(calc(28.6% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 480px) and (max-width: 499px) {
            .sheet-content_nw4 {
                transform: scale(calc(30% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 500px) and (max-width: 519px) {
            .sheet-content_nw4 {
                transform: scale(calc(30% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 520px) and (max-width: 539px) {
            .sheet-content_nw4 {
                transform: scale(calc(30% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 540px) and (max-width: 559px) {
            .sheet-content_nw4 {
                transform: scale(calc(33.6% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 560px) and (max-width: 579px) {
            .sheet-content_nw4 {
                transform: scale(calc(35% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 580px) and (max-width: 599px) {
            .sheet-content_nw4 {
                transform: scale(calc(36% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 600px) and (max-width: 629px) {
            .sheet-content_nw4 {
                transform: scale(calc(37.5% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 630px) and (max-width: 669px) {
            .sheet-content_nw4 {
                transform: scale(calc(38.6% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 670px) and (max-width: 699px) {
            .sheet-content_nw4 {
                transform: scale(calc(42% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 700px) and (max-width: 739px) {
            .sheet-content_nw4 {
                transform: scale(calc(44% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 740px) and (max-width: 769px) {
            .sheet-content_nw4 {
                transform: scale(calc(46% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 770px) and (max-width: 799px) {
            .sheet-content_nw4 {
                transform: scale(calc(48% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (max-width: 767px) {
            .sheet-content_nw4 {
                margin: 0 auto;
            }
        }

        @media print {
            .sheet-content_nw4 {
                transform: scale(1) !important;
            }

            .tfoot_bg td {
                padding: 2px 10px;
                background: #efefef !important;
                font-size: 12px;
                -webkit-print-color-adjust: exact
            }

            .Heading_right {
                background: #efefef !important;
                -webkit-print-color-adjust: exact;
                border-top: 1px solid #ccc !important
            }
        }

        @page {
            margin: 0px;
            padding: 5px 0;
        }

      `}</style>

            <div className="sheet-content">
                <section className="sheet padding-2mm">
                    <div id="printableArea221">
                        <table style={{ width: '100%' }} cellPadding="0" cellSpacing="0">
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="invoice-box">
                                            <div className="border_box">
                                                <table cellPadding="0" cellSpacing="0">
                                                    <tbody>
                                                        <tr className="top">
                                                            <td>
                                                                <table cellPadding="0" cellSpacing="0">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td style={{ width: '60%' }} className="left_table">
                                                                                <table cellPadding="0" cellSpacing="0">
                                                                                    <thead>
                                                                                        <tr>
                                                                                            <th colSpan="2" className="top_heading_left">
                                                                                                <div className="top_heading">
                                                                                                    <p className="top_heading_P">{company_name}</p>
                                                                                                    <p className="Address">
                                                                                                        <span>{address}</span>
                                                                                                        <span>{email}, {phone}</span>
                                                                                                    </p>
                                                                                                    <p className="Gst_in">{gstin}</p>
                                                                                                </div>
                                                                                            </th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                </table>
                                                                            </td>
                                                                            <td style={{ width: '40%' }}>
                                                                                <table className="table_right new_table" cellPadding="0" cellSpacing="0">
                                                                                    <thead>
                                                                                        <tr>
                                                                                            <td colSpan="2">
                                                                                                <table className="table_gray_bg">
                                                                                                    <tbody>
                                                                                                        <tr>
                                                                                                            <td className="bold_text width_35">L.R.COPY</td>
                                                                                                            <td className="text-left width_75 font14">
                                                                                                                <span>({activeCopy.name})</span>
                                                                                                                <span className="number">({activeCopy.value})</span>
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                    </tbody>
                                                                                                </table>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        <tr><td className="bold_text width_35">Trip No.</td><td className="text-left width_75">{trip_no}</td></tr>
                                                                                        <tr><td className="bold_text width_35">Vehicle No.</td><td className="text-left width_75">{vehicle_no}</td></tr>
                                                                                        <tr><td className="bold_text width_35">Date</td><td className="text-left width_75">{lr_date}</td></tr>
                                                                                        <tr><td className="bold_text width_35">MLR No.</td><td className="text-left width_75">{mlr_no}</td></tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>

                                                        {/* Consigner & Consignee */}
                                                        <tr>
                                                            <td style={{ borderTop: '1px solid #ccc' }}>
                                                                <table width="100%" cellPadding="0" cellSpacing="0">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td style={{ width: '50%', borderRight: '1px solid #ccc', paddingTop: '3px', paddingBottom: '3px', paddingRight: '0px' }}>
                                                                                <table style={{ width: '100%' }} cellSpacing="0" cellPadding="0">
                                                                                    <tbody>
                                                                                        <tr><td colSpan="1" style={{ paddingLeft: '15px' }}><p style={{ margin: '0px' }}><strong>CONSIGNER-</strong> {consigner_name}</p></td></tr>
                                                                                        <tr><td colSpan="1" style={{ height: '40px', paddingLeft: '15px' }}>
                                                                                            <p style={{ marginBottom: '0px', marginTop: '0px' }}><strong>{consigner_c_o}</strong></p>
                                                                                            <p className="address_new">{consigner_address}</p>
                                                                                        </td></tr>
                                                                                        <tr><td style={{ paddingLeft: '15px' }}><p style={{ marginBottom: '5px', marginTop: '0px' }}><strong>GSTIN-</strong> {consigner_gstin}</p></td></tr>
                                                                                        <tr><td style={{ paddingLeft: '15px', borderTop: '1px solid #ccc' }}><p className="item_description"><strong>Item Description-</strong> {item_desc}</p></td></tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </td>
                                                                            <td style={{ width: '50%', paddingTop: '3px', paddingLeft: '8px', paddingBottom: '3px', paddingRight: '15px' }}>
                                                                                <table style={{ width: '100%' }} cellSpacing="0" cellPadding="0">
                                                                                    <tbody>
                                                                                        <tr><td colSpan="1"><table><tbody>
                                                                                            <tr><td style={{ width: '15%' }}><strong>CONSIGNEE-</strong></td><td colSpan="3"><span style={{ fontWeight: 'bold' }}>{consignee_name}</span></td></tr>
                                                                                            <tr><td style={{ width: '15%', paddingBottom: '10px' }}><strong>ADDRESS-</strong></td><td colSpan="3" style={{ paddingBottom: '10px', width: '85%', height: '44px' }}>{consignee_address}</td></tr>
                                                                                            <tr><td style={{ width: '15%' }}><strong>CONTACT-</strong></td><td colSpan="3">{consignee_contact}</td></tr>
                                                                                            <tr>
                                                                                                <td style={{ width: '15%' }}><strong>GSTIN-</strong></td>
                                                                                                <td>{consignee_gstin}</td>
                                                                                                <td style={{ width: '13%', textAlign: 'right' }}><strong>CODE-</strong></td>
                                                                                                <td style={{ textAlign: 'left' }}><span style={{ marginLeft: '40px' }}>{consignee_code}</span></td>
                                                                                            </tr>
                                                                                        </tbody></table></td></tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>

                                                        {/* Invoice Table */}
                                                        <tr>
                                                            <td>
                                                                <div className="height_div gst_invoiceno_table">
                                                                    <table cellPadding="0" cellSpacing="0" className="border_table border_none">
                                                                        <thead>
                                                                            <tr>
                                                                                {visibleColumns.map((col, i) => (
                                                                                    <td key={i} className="graY-bg">{col.name}</td>
                                                                                ))}
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody style={{ borderBottom: '1px solid #ccc' }}>
                                                                            <tr>
                                                                                {visibleColumns.map((col, i) => (
                                                                                    <td key={i}>{tableData[col.key] || '-'}</td>
                                                                                ))}
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        {/* Remark */}
                                                        <tr>
                                                            <td>
                                                                <table cellPadding="0" cellSpacing="0" className="holding_table">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td style={{ width: '50%', borderBottom: '1px solid #ccc' }}>
                                                                                <p style={{ fontWeight: 'bold', paddingLeft: '15px', paddingRight: '10px', marginTop: '5px', lineHeight: '15px', fontSize: '10px' }}>
                                                                                    <strong>Remark:</strong> {remark}
                                                                                </p>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>

                                                        {/* Terms & Signatures */}
                                                        <tr>
                                                            <td>
                                                                <table cellPadding="0" cellSpacing="0" className="holding_table">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td style={{ width: '50%', borderRight: '1px solid #ccc' }}>
                                                                                <p style={{ fontWeight: 'bold', paddingLeft: '15px', paddingRight: '10px', marginTop: '5px', lineHeight: '15px', fontSize: '10px' }}>
                                                                                    <strong>Terms &amp; Conditions:</strong> {terms_conds}
                                                                                </p>
                                                                            </td>
                                                                            <td style={{ width: '50%' }}>
                                                                                <table style={{ width: '100%' }} cellSpacing="0" cellPadding="0">
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td style={{ width: '50%' }}>
                                                                                                <div className="footer margintop" style={{ textAlign: 'left' }}>
                                                                                                    <p style={{ color: '#707070', fontWeight: '400' }}>Driver</p>
                                                                                                </div>
                                                                                            </td>
                                                                                            <td style={{ width: '50%' }}>
                                                                                                <div className="footer margintop" style={{ textAlign: 'right' }}>
                                                                                                    <p style={{ color: '#707070', fontWeight: '400' }}>Authorized Signature</p>
                                                                                                </div>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    {/* Spoiled Stock Declaration */}
                    <div className="__stockSpoil_bx">
                        <div className="__stk_head">
                            <h4>Spoil stock Declaration</h4>
                            <p>Please fill out the form below to declare any spoil stock.</p>
                        </div>

                        <div className="__stk_tpDetail">
                            <div className="__stk_lFx">
                                <p>Date</p>
                                <span>{modifyForm.spoil_date || ''}</span>
                            </div>
                            <div className="__stk_lFx">
                                <p>For the Month of</p>
                                <span>{modifyForm.spoil_month || ''}</span>
                            </div>
                            <div className="__stk_lFx __stk_lFx_full">
                                <p>Spoil Quantity</p>
                                <span>{modifyForm.spoil_quantity || ''}</span>
                            </div>
                        </div>

                        <div className="__stk_tpDetail __stk_tpDetail_last">
                            <div className="__stk_lFx"><p>TICK CORRECTLY</p></div>

                            <div className="__stk_lFx __stk_lFx_full">
                                <p>
                                    <span
                                        className="__stk_check"
                                        style={{ backgroundColor: modifyForm.spoil_option === 'not_available' ? '#000' : 'transparent' }}
                                    ></span>
                                    Spoil Stock Not Available
                                </p>
                            </div>

                            <div className="__stk_lFx __stk_lFx_full">
                                <p>
                                    <span
                                        className="__stk_check"
                                        style={{ backgroundColor: modifyForm.spoil_option === 'doc_not_ready' ? '#000' : 'transparent' }}
                                    ></span>
                                    Spoil Stock Document Not Ready
                                </p>
                            </div>

                            <div className="__stk_lFx __stk_lFx_full">
                                <p>
                                    <span
                                        className="__stk_check"
                                        style={{ backgroundColor: modifyForm.spoil_option === 'other' ? '#000' : 'transparent' }}
                                    ></span>
                                    Any Other Reason:
                                </p>
                                <span>{modifyForm.spoil_other_reason || ''}</span>
                            </div>
                        </div>

                        <div className="stk_signBx">
                            <p>W/S STAMP & SIGNATURE</p>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default Format7;